import { IFile } from 'app/models/file';
import { Author } from 'app/models/author';
import { Source } from 'app/models/source.enum';
import {IAsset} from 'app/models/asset.interface'
export class Topic implements IAsset{
  id: string;
  parentId: string;
  name: string;
  displayName: string;
  description: string;
  createdTime: number;
  updateDate: number;
  author?: Author;
  files: Array<IFile>;
  source: Source;

  constructor(
    id: string,
    parentId: string,
    name: string,
    displayName: string,
    description: string,
    createdTime: number,
    updateDate: number,
    author: Author,
    files: Array<IFile>
  ) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.displayName = displayName;
    this.description = description;
    this.createdTime = createdTime;
    this.updateDate = updateDate;
    this.author = author;
    this.files = files;
    this.source = Source.Topic;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/topic.ts